import { render } from "./userTela.vue?vue&type=template&id=6d4845e2&scoped=true"
import script from "./userTela.vue?vue&type=script&lang=js"
export * from "./userTela.vue?vue&type=script&lang=js"

import "./userTela.vue?vue&type=style&index=0&id=6d4845e2&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4845e2"]])

export default __exports__